module.exports = __webpack_public_path__ + "static/media/email.571a71b9.svg";